<form [formGroup]="form" [formEditablePermission]="form">
  <h6 i18n>Invoice Header</h6>
  <div class="row">
    <div class="col-6">
      <mat-form-field2 class="mat-block">
        <input rows="5" matInput formControlName="invoice_header" i18n-placeholder placeholder="Invoice Header" />
        <mat-hint align="end" i18n>Default is "Invoice"</mat-hint>
      </mat-form-field2>
    </div>
  </div>

  <h6 i18n>Notes</h6>

  <div class="card p-3">
    <mat-form-field2 class="mat-block">
      <textarea
        matInput
        rows="5"
        i18n-placeholder
        placeholder="Payment Terms(visible to guest on invoice)"
        formControlName="paymentTerms"
        cdkTextareaAutosize
      ></textarea>
    </mat-form-field2>
  </div>
  <div class="d-flex gap-3 mt-3">
    <div class="card p-3 flex-1">
      <mat-form-field2 class="mat-block">
        <textarea
          matInput
          rows="5"
          i18n-placeholder
          placeholder="Payment Instructions(visible to guest on invoice)"
          formControlName="paymentInstructions"
          cdkTextareaAutosize
        ></textarea>
      </mat-form-field2>
    </div>

    <div class="card p-3 flex-1">
      <mat-form-field2 class="mat-block">
        <textarea
          matInput
          rows="5"
          i18n-placeholder
          placeholder="Notes(visible to guest on invoice)"
          formControlName="notes"
          cdkTextareaAutosize
        ></textarea>
      </mat-form-field2>
    </div>
  </div>
</form>
